import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import  { get } from 'lodash';
import { push } from 'react-router-redux';

import NavigationSidebar from '../../../common/components/NavigationSidebar';

@connect((store) => ({
    user: store.user
}), {
  push
})

export default class Settings extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.any,
    route: PropTypes.object,
    location: PropTypes.object,
    user: PropTypes.object
  }

  render() {

    const roles = get(this.props.user, 'roles', []);
    const isAdmin = roles.includes('Admin');
    const isSysAdmin = roles.includes('System Administrator');

    let links = [];

    if(isAdmin) {
      links.push({
        title: 'Users',
        href: '/admin/settings/users'
      });

      links.push({
        title: 'Emails',
        href: '/admin/settings/emails'
      });
    }

    if (isSysAdmin) {
      links.push({
        title: 'Recent Password Reset Requests',
        href: '/admin/settings/PasswordResetRequests'
      });

      links.push({
        title: 'Push Queue Items',
        href: '/admin/settings/PushQueueItems'
      });
    }

    return (<div className='settings'>
      <NavigationSidebar
          links={links}
          title={'Profile'}
      />
      <div className='settings-tab-container'>
      {
        this.props.children
      }
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/index.js